import { createBrowserRouter, Navigate, type RouteObject } from 'react-router';

import { AlertsScreen } from '../alerts/AlertsScreen';
import { LoginScreen } from '../auth/LoginScreen';
import { ProtectedRoute } from '../auth/ProtectedRoute';
import { CaptureScreen } from '../capture/CaptureScreen';
import { NotesScreen } from '../history/NotesScreen';
import { ReviewScreen } from '../review/ReviewScreen';
import { SettingsScreen } from '../settings/SettingsScreen';
import { NotFoundScreen } from '../shell/NotFoundScreen';
import { RouteErrorScreen } from '../shell/RouteErrorScreen';
import { AppLayout } from './AppLayout';

/**
 * Route table. `/iniciar-sesion` is the one public route. Everything else sits behind
 * `ProtectedRoute` (CLAUDE.md rule 10: authenticate every note/image/alert/history/settings
 * route). The index route redirects to `/capturar`: capture is the signed-in landing screen
 * (`docs/tech-stack.md` §2, `docs/implementation/06-mobile-web.md` 6.2), and redirecting to
 * one canonical path - rather than also rendering `CaptureScreen` at `/` - keeps `TopNav`'s
 * `isActive` highlighting correct and keeps a single URL for the screen. `notas/:id` is the
 * full-note review editor (6.4); Alerts and Settings remain navigation placeholders until their
 * own subphases (6.5–6.6).
 */
export const routes: RouteObject[] = [
  {
    path: '/',
    element: <AppLayout />,
    errorElement: <RouteErrorScreen />,
    children: [
      { path: 'iniciar-sesion', element: <LoginScreen /> },
      {
        element: <ProtectedRoute />,
        children: [
          { index: true, element: <Navigate to="/capturar" replace /> },
          { path: 'capturar', element: <CaptureScreen /> },
          { path: 'notas', element: <NotesScreen /> },
          { path: 'notas/:id', element: <ReviewScreen /> },
          { path: 'alertas', element: <AlertsScreen /> },
          { path: 'ajustes', element: <SettingsScreen /> },
          { path: '*', element: <NotFoundScreen /> },
        ],
      },
    ],
  },
];

export function createAppRouter() {
  return createBrowserRouter(routes);
}
